import React from 'react';
import { CheckCircleOutlined, WarningOutlined, CloseCircleOutlined } from '@ant-design/icons';

interface VerdictMatrix {
  indicator: string;
  value: string;
  status: 'good' | 'warning' | 'bad';
  advice: string;
}

interface Props {
  status: 'good' | 'warning' | 'bad';
  title: string;
  message: string;
  details?: string[];
  matrix?: VerdictMatrix[];
}

const VERDICT_CONFIG = {
  good: {
    icon: <CheckCircleOutlined style={{ fontSize: 24 }} />,
    bg: 'linear-gradient(135deg, #e8f8ee, #c3e6cb)',
    border: '#15be53',
    color: '#0a6b2e',
    label: '合格',
  },
  warning: {
    icon: <WarningOutlined style={{ fontSize: 24 }} />,
    bg: 'linear-gradient(135deg, #fef8e8, #ffeaa7)',
    border: '#e6a200',
    color: '#7a5500',
    label: '预警',
  },
  bad: {
    icon: <CloseCircleOutlined style={{ fontSize: 24 }} />,
    bg: 'linear-gradient(135deg, #fde8ec, #f5c6cb)',
    border: '#df1b41',
    color: '#8b1029',
    label: '不合格',
  },
};

const VerdictCard: React.FC<Props> = ({ status, title, message, details, matrix }) => {
  const cfg = VERDICT_CONFIG[status];

  return (
    <div style={{ marginBottom: 16 }}>
      {/* Main verdict banner */}
      <div style={{
        background: cfg.bg, borderLeft: `5px solid ${cfg.border}`,
        borderRadius: 10, padding: 20, color: cfg.color,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
          {cfg.icon}
          <div>
            <div style={{ fontSize: 18, fontWeight: 700 }}>{title}</div>
            <div style={{ fontSize: 12, opacity: 0.8 }}>{cfg.label}</div>
          </div>
        </div>
        <p style={{ fontSize: 14, lineHeight: 1.8, margin: 0 }}>{message}</p>
        {details && details.length > 0 && (
          <ul style={{ margin: '8px 0 0', paddingLeft: 20, fontSize: 13, lineHeight: 1.8 }}>
            {details.map((d, i) => <li key={i}>{d}</li>)}
          </ul>
        )}
      </div>

      {/* Verdict matrix table */}
      {matrix && matrix.length > 0 && (
        <div className="card-trendata" style={{ padding: 16, marginTop: 12 }}>
          <h4 style={{ margin: '0 0 12px', fontSize: 14, fontWeight: 600, color: '#061b31' }}>
            判定矩阵
          </h4>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '8px 12px', borderBottom: '2px solid #533afd', color: '#061b31' }}>指标</th>
                <th style={{ textAlign: 'center', padding: '8px 12px', borderBottom: '2px solid #533afd', color: '#061b31' }}>值</th>
                <th style={{ textAlign: 'center', padding: '8px 12px', borderBottom: '2px solid #533afd', color: '#061b31' }}>状态</th>
                <th style={{ textAlign: 'left', padding: '8px 12px', borderBottom: '2px solid #533afd', color: '#061b31' }}>建议</th>
              </tr>
            </thead>
            <tbody>
              {matrix.map((row, i) => {
                const rowCfg = VERDICT_CONFIG[row.status];
                return (
                  <tr key={i}>
                    <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee', fontWeight: 500 }}>{row.indicator}</td>
                    <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee', textAlign: 'center', fontFamily: 'monospace', fontWeight: 600 }}>{row.value}</td>
                    <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee', textAlign: 'center' }}>
                      <span style={{ color: rowCfg.color, background: rowCfg.bg.includes('gradient') ? undefined : rowCfg.bg, padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>
                        {rowCfg.label}
                      </span>
                    </td>
                    <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee', fontSize: 12, color: '#666' }}>{row.advice}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VerdictCard;
